// "Sign in | Create account" segmented control above the card (iOS SignInView.modePicker). The two sides are the
// /sign-in and /sign-up routes, so it is a pair of links styled as a segmented picker.

import { clsx } from 'clsx';
import { Link } from 'react-router';

export function AuthModeSwitch({ mode, disabled }: { mode: 'signIn' | 'signUp'; disabled?: boolean }) {
  const item = (to: string, label: string, active: boolean) => (
    <Link
      to={to}
      replace
      aria-current={active ? 'page' : undefined}
      tabIndex={disabled ? -1 : undefined}
      onClick={(e) => {
        if (disabled || active) e.preventDefault();
      }}
      className={clsx(
        'flex-1 rounded-xl px-3 py-2 text-center text-sm font-semibold transition',
        active
          ? 'bg-white text-[var(--gt-navy)] shadow-sm dark:bg-slate-700 dark:text-white'
          : 'text-slate-600 hover:text-slate-900 dark:text-slate-300 dark:hover:text-white',
        disabled && !active && 'pointer-events-none opacity-60',
      )}
    >
      {label}
    </Link>
  );
  return (
    <nav aria-label="Sign in or create an account" className="flex gap-1 rounded-2xl bg-slate-200/70 p-1 dark:bg-slate-800">
      {item('/sign-in', 'Sign in', mode === 'signIn')}
      {item('/sign-up', 'Create account', mode === 'signUp')}
    </nav>
  );
}
